import React, { ReactNode } from 'react';

interface Props {
  when?: boolean;
  children: ReactNode;
}

const Visible = (props: Props, ref: React.Ref<any>) => {
  const { when, children } = props;
  if (when === true) {
    return <>{typeof children === 'function' ? children(ref) : children}</>;
  } else {
    return null;
  }
};

export default React.forwardRef(Visible);
